import React from 'react';
import { Typography } from '@mui/material';
import NonNavHeader from '../layouts/components/NonNavHeader';
import NonNavFooter from '../layouts/components/NonNavFooter';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import AppConfig from '../config/app.json';

const NotFoundView = (props) => {
  const { hideHeader, hideFooter, } = props;

  document.title = `Page Not Found | ${AppConfig.product_name}`;

  return (
    <div style={{height:"100vh",overflow:"scroll"}}>
      {!hideHeader && (
        <NonNavHeader />
      )}
      <Container
        maxWidth="md"
        style={{height:"100vh"}}
      >
        <Grid container>
          <Grid item md={2}></Grid>
          <Grid item md={8} sm={12} xs={12} style={{marginTop: 20, textAlign: 'center'}}>
            <div style={{ marginBottom: "10%",  marginTop: "10%"}}>
              <Typography color="primary" variant="h2">Page Not Found</Typography>
              <Typography color="textSecondary">Sorry but the page you are looking for may be expired or unavailable.</Typography>
              <img style={{width: '70%'}} src="/images/404.svg" alt="Mobile illustrations by Storyset"/>
            </div>
          </Grid>
          <Grid item md={2}></Grid>
        </Grid>
      </Container>
      {!hideFooter && (
        <div
          style={{bottom: 0, width: "100%",}}
        >
          <NonNavFooter />
        </div>
      )}
    </div>
  )
}

export default NotFoundView;